"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParam = void 0;
var navigate_1 = require("./navigate");
function queryParam(name) {
    return queryParams().get(name) || "";
}
var queryParams = function () { return new URLSearchParams(location.search); };
function useQueryParam(name) {
    var link = function (value) {
        var u = new URL(location.href);
        u.hash = "";
        u.searchParams.set(name, value);
        return u.href;
    };
    var setter = function (value) { return navigate_1.navigate(link(value)); };
    setter.link = link;
    return [queryParam(name), setter];
}
exports.useQueryParam = useQueryParam;
//# sourceMappingURL=queryParams.js.map